// Pure UA/platform detection for the Downloads page: map the visitor's user
// agent (plus optional UA client hints) to the platform card to recommend.
// Lives in lib/ rather than in Downloads.tsx so the web package's node-env
// vitest (see vitest.config.ts) can import it directly — importing the page
// would drag in its auth/react-router dependencies, which need a DOM.
//
// Neomaris Core ships for Linux only, so a visitor on any other system gets no
// recommendation.

export type PlatformId = 'linux-deb' | 'linux-arm64';

export type UAData = {
  platform?: string;
};

export function detectPlatform(ua: string, uaData?: UAData): PlatformId | null {
  const platformHint = uaData?.platform ?? '';
  if (/Linux/i.test(ua) || /Linux/i.test(platformHint)) return 'linux-deb';
  return null;
}
